/**
 * Как определяется, какой прайс показать:
 * — Для работодателя или бекофиса с employerId — по региону работодателя
 * — Для соискателя, анонима и бекофиса без employerId — по домену
 */
enum PriceCountryCode {
    AZ = 'AZ',
    BY = 'BY',
    GE = 'GE',
    KZ = 'KZ',
    KG = 'KG',
    RU = 'RU',
    UZ = 'UZ',
}

export default PriceCountryCode;
